<template>
  <div>
    <page-header :title="$t('bill.product_type_maintenance')" :tabs="cloudEnvOptions" :current-tab.sync="cloudEnv" />
    <page-body>
      <product-list :id="listId" :cloud-env="cloudEnv" />
    </page-body>
  </div>
</template>

<script>
import ProductList from './components/List'

export default {
  name: 'BillProductIndex',
  components: {
    ProductList,
  },
  data () {
    return {
      listId: 'BillProductList',
      cloudEnvOptions: [
        { key: 'dictionary', label: this.$t('bill.dictionary_maintenance') },
        { key: 'mapping', label: this.$t('bill.mapping_maintenance') },
      ],
      cloudEnv: 'dictionary',
    }
  },
}
</script>
